// Patient tabs stay fixed (Quotes hosts the Pay-now banner); Care is reached from Home and the header.
export const MOBILE_NAV_KEYS_BY_ROLE = {
  patient: ['dashboard', 'quotes', 'messages', 'travel', 'payments'],
  doctor: ['dashboard', 'patients', 'messages', 'quotes', 'payments'],
  // Staff get 4 destinations + a "More" item that opens the full sidebar sheet.
  admin: ['dashboard', 'messages', 'calls', 'payments'],
  super_admin: ['dashboard', 'patients', 'messages', 'calls'],
} as const;

export const shouldShowMobileBottomNav = (isMessagesChatWindow: boolean) => !isMessagesChatWindow;

export const getMobileShellClassName = ({
  isMessagesShellRoute,
  isMessagesChatWindow,
}: {
  isMessagesShellRoute: boolean;
  isMessagesChatWindow: boolean;
}) =>
  isMessagesChatWindow
    ? 'flex h-dvh min-h-0 webview-safe-screen flex-col overflow-hidden bg-background'
    : isMessagesShellRoute
      ? 'flex min-h-dvh webview-safe-screen flex-col overflow-hidden bg-background'
      : 'flex min-h-dvh webview-safe-screen flex-col bg-background';
